import React, { useEffect, useState } from 'react';
import './CenterTyping.css';

const CenterTyping = ({ text, speed = 100 }) => {
  const [visibleText, setVisibleText] = useState('');

  useEffect(() => {
    const mid = Math.floor(text.length / 2);
    let left = mid - 1;
    let right = mid + 1;
    let result = text[mid] || '';


    const interval = setInterval(() => {
      if (left >= 0 || right < text.length) {
        result = (left >= 0 ? text[left--] : '') + result + (right < text.length ? text[right++] : '');
        setVisibleText(result);
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return (
    <div className="typing-container">
      <span className="typing-text">{visibleText}</span>
    </div>
  );
};

export default CenterTyping;
